export const adDisplaysBeforeRefreshValues = ['1', '2', '3', '4', '5'] as const

export type AdDisplaysBeforeRefresh = (typeof adDisplaysBeforeRefreshValues)[number]
